import React from 'react';
import './PageStyles.css';

const Privacy = () => {
    return (
        <div className="page-container">
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1 className="page-hero-title">Privacy Policy</h1>
                    <p className="page-hero-subtitle">
                        Learn how we protect and handle your personal information.
                    </p>
                </div>
            </section>
            <section className="value-props-section">
                <div className="value-props-container">
                    <p>Content coming soon...</p>
                </div>
            </section>
        </div>
    );
};

export default Privacy;

